module.exports = __webpack_public_path__ + "img/default-avatar.ef4ff74f.png";